import {
  EmphasisBlock, media, PrimarySubmitButton, ActionBar, BlockGroup, SecondaryButton, WarningIcon,
} from 'ia-react-core';
import styled from 'styled-components';

export const StyledFormDiv = styled.div`
    margin-top: 36px;
`;

export const StyledBlockGroup = styled(BlockGroup)`
  box-shadow: none;
`;

export const StyledEmphasisBlock = styled(EmphasisBlock)`
  padding: 0px;
  box-shadow: rgb(0 0 0 / 6%) 0px 2px 0px 0px;
`;

export const StyledPrimaryButton = styled(PrimarySubmitButton)`
  flex:2;
`;

export const StyledSecondaryButton = styled(SecondaryButton)`
  flex:0.8;
  flex-basis: unset;
`;

export const StyledActionBar = styled(ActionBar)`
  flex-direction: column;
  ${media.sm`
    flex-direction: row;
    display: flex;
  `};
`;

export const StyledIcon = styled(WarningIcon)`
  color: ${({ theme }) => theme.colors.orange2};
`;
